import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLine,
  faTelegram,
  faWhatsapp,
} from '@fortawesome/free-brands-svg-icons';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import Clients from '../components/Clients';
import Cta from '../components/Cta';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import Intro from '../components/Intro';
import Portfolio from '../components/Portfolio';
import Ourmassages from '../components/OurMassages';

const actions = [
  {
    href: 'https://wa.me/+66641831185',
    label: 'WhatsApp',
    icon: faWhatsapp,
    className: 'text-green-500',
  },
  {
    href: 'https://line.me/R/ti/p/%40886yoeiq',
    label: 'Line',
    icon: faLine,
    className: 'text-green-600',
  },
  {
    href: 'https://t.me/+66641831185',
    label: 'Telegram',
    icon: faTelegram,
    className: 'text-sky-500',
  },
];

const Home = () => {
  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <Hero />
      <Intro />
      <Ourmassages />
      <Portfolio />
      <Clients />
      <Cta />
      <Footer />

      <div className="fixed bottom-5 right-5 z-40 flex flex-col gap-3">
        {actions.map((action) => (
          <a
            key={action.label}
            href={action.href}
            target="_blank"
            rel="noreferrer"
            aria-label={action.label}
            className={`flex h-12 w-12 items-center justify-center rounded-full border border-white/70 bg-white/90 text-lg shadow-lg shadow-slate-900/10 backdrop-blur transition hover:-translate-y-0.5 ${action.className}`}
          >
            <FontAwesomeIcon icon={action.icon} />
          </a>
        ))}
      </div>

      <div className="fixed bottom-5 left-5 z-40">
        <button
          type="button"
          onClick={handleScrollToTop}
          aria-label="Scroll to top"
          className="flex h-12 w-12 items-center justify-center rounded-full bg-slate-900 text-white shadow-lg shadow-slate-900/20 transition hover:bg-slate-700"
        >
          <FontAwesomeIcon icon={faArrowUp} />
        </button>
      </div>
    </>
  );
};

export default Home;
